var map = {
	"./example.svg": "./src/icons/svg/example.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./icon-2dmap.svg": "./src/icons/svg/icon-2dmap.svg",
	"./icon-areaselect.svg": "./src/icons/svg/icon-areaselect.svg",
	"./icon-clean.svg": "./src/icons/svg/icon-clean.svg",
	"./icon-close.svg": "./src/icons/svg/icon-close.svg",
	"./icon-device.svg": "./src/icons/svg/icon-device.svg",
	"./icon-distance.svg": "./src/icons/svg/icon-distance.svg",
	"./icon-doublescreen.svg": "./src/icons/svg/icon-doublescreen.svg",
	"./icon-down.svg": "./src/icons/svg/icon-down.svg",
	"./icon-earth.svg": "./src/icons/svg/icon-earth.svg",
	"./icon-eraser.svg": "./src/icons/svg/icon-eraser.svg",
	"./icon-gis.svg": "./src/icons/svg/icon-gis.svg",
	"./icon-hand.svg": "./src/icons/svg/icon-hand.svg",
	"./icon-home.svg": "./src/icons/svg/icon-home.svg",
	"./icon-infomgr.svg": "./src/icons/svg/icon-infomgr.svg",
	"./icon-layers.svg": "./src/icons/svg/icon-layers.svg",
	"./icon-maintain.svg": "./src/icons/svg/icon-maintain.svg",
	"./icon-manage.svg": "./src/icons/svg/icon-manage.svg",
	"./icon-menu.svg": "./src/icons/svg/icon-menu.svg",
	"./icon-message.svg": "./src/icons/svg/icon-message.svg",
	"./icon-minus.svg": "./src/icons/svg/icon-minus.svg",
	"./icon-pick.svg": "./src/icons/svg/icon-pick.svg",
	"./icon-pipe.svg": "./src/icons/svg/icon-pipe.svg",
	"./icon-pipeanalyse.svg": "./src/icons/svg/icon-pipeanalyse.svg",
	"./icon-plus.svg": "./src/icons/svg/icon-plus.svg",
	"./icon-printer.svg": "./src/icons/svg/icon-printer.svg",
	"./icon-quit.svg": "./src/icons/svg/icon-quit.svg",
	"./icon-repair.svg": "./src/icons/svg/icon-repair.svg",
	"./icon-right.svg": "./src/icons/svg/icon-right.svg",
	"./icon-ring.svg": "./src/icons/svg/icon-ring.svg",
	"./icon-search.svg": "./src/icons/svg/icon-search.svg",
	"./icon-select.svg": "./src/icons/svg/icon-select.svg",
	"./icon-setting.svg": "./src/icons/svg/icon-setting.svg",
	"./icon-singlescreen.svg": "./src/icons/svg/icon-singlescreen.svg",
	"./icon-splitscreen.svg": "./src/icons/svg/icon-splitscreen.svg",
	"./icon-statistic.svg": "./src/icons/svg/icon-statistic.svg",
	"./icon-up.svg": "./src/icons/svg/icon-up.svg",
	"./icon-user.svg": "./src/icons/svg/icon-user.svg",
	"./icon-wrap.svg": "./src/icons/svg/icon-wrap.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./user.svg": "./src/icons/svg/user.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";